module.exports = __webpack_public_path__ + "img/west_gat_chapel.13eb3b7e.png";